module.exports = __webpack_public_path__ + "img/cloth_g1_shirt_05.e79d4f1d.svg";